export default [
    {        
        method: 'commonGameList',
        type: 'GET',
        path: '/komoe/api/common/game/list',
        mode: 'cs',
        params: [],
        options: { cache: false, },
        switch: true,
        // desc: '获取游戏列表'
    },
    {        
        method: 'commonQuestionList',
        type: 'GET',
        path: '/komoe/api/common/faq/page',
        mode: 'cs',
        params: ['game_base_id', 'question_type', 'page_num', 'page_size', 'question_keyword'],
        options: { cache: false, },
        switch: true,
        // desc: '获取游戏列表'
    },
    {
        method: "getWorkOrder",
        type: 'POST',
        path: '/komoe/api/work_order/page',
        mode: 'cs',
        params: ["work_order_status","page_num","page_size","ct"],
        options: { dataFormat: "json", withCredentials: true, cache: false, },
        switch: true,
        // desc: '工单列表分页接口'
    },
    {
        method: "getConnectInfo",
        type: 'GET',
        path: '/komoe/api/contacts/info',
        mode: 'cs',
        params: ["ct"],
        options: { withCredentials: true, cache: false, },
        switch: true,
        // desc: '获取联系信息'
    },
    {
        method: "saveConnectInfo",
        type: 'POST',
        path: '/komoe/api/contacts/save',
        mode: 'cs',
        params: ["contacts","sex","mobile","email","address","ct"],
        options: { withCredentials: true, cache: false, },
        switch: true,
        // desc: '联系信息保存'
    },
    {
        method: "getOrderDetail",
        type: 'GET',
        path: '/komoe/api/work_order/detail',
        mode: 'cs',
        params: ["work_order_id"],
        options: { withCredentials: true, cache: false, },
        switch: true,
        // desc: '获取工单详细信息'
    },
    {
        method: "postOrderGrade",
        type: 'POST',
        path: '/komoe/api/work_order/grade',
        mode: 'cs',
        params: ["work_order_id","grade","ct"],
        options: { withCredentials: true, cache: false, },
        switch: true,
        // desc: '送出工单处理评分'
    },
    {
        method: "commonQuestionTypeList",
        type: 'GET',
        path: '/komoe/api/common/question_type/list',
        mode: 'cs',
        params: ["usage"],
        options: {cache: false, },
        switch: true,
        // desc: '获取问题类型列表'
    },
    {
        method: "newWordOrder",
        type: 'POST',
        path: '/komoe/api/work_order/create',
        mode: 'cs',
        params: ["parent_work_order_id","game_base_id","character_id","character_name","email","question_type","question_title","question_content","source","attachments","ct"],
        options: { dataFormat: "json", withCredentials: true , cache: false },
        switch: true,
        // desc: '新建工单'
    },
    {
        method: "upload",
        type: 'POST',
        path: '/komoe/api/common/file/upload',
        mode: 'uploadS',
        options: { dataFormat: "multipart/form-data", withCredentials: true , cache: false },
        switch: true
    }
];